module.exports = __webpack_public_path__ + "static/media/logo-hkjc.2c945415.png";